function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 580"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 120",
  d: "M1.328 14.451a.764.764 0 00.763.732h7.133a.764.764 0 00.763-.732l.509-10.754H.819zm5.944-8.083a.31.31 0 01.31-.31h.5a.31.31 0 01.31.31v6.144a.31.31 0 01-.31.31h-.5a.31.31 0 01-.31-.31zm-2.172 0a.31.31 0 01.31-.31h.5a.31.31 0 01.31.31v6.144a.31.31 0 01-.31.31h-.5a.31.31 0 01-.31-.31V6.368zm-2.172 0a.31.31 0 01.31-.31h.5a.31.31 0 01.31.31v6.144a.31.31 0 01-.31.31h-.5a.31.31 0 01-.31-.31z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 121",
  d: "M10.837.782H7.546V.16A.16.16 0 007.384 0H3.93a.16.16 0 00-.16.16v.622H.484a.479.479 0 00-.479.48v1.506h11.311V1.262a.479.479 0 00-.479-.48z"
}));

var SvgInputDelete = function SvgInputDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11.316 15.184",
    width: 30,
    height: 30,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInputDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/input-delete.4c9fe899.svg";
export { ForwardRef as ReactComponent };